import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { SymbolComponent } from '@core/symbol-legacy';
import { BadgeComponent, HeadingComponent, TruncateComponent } from '@core/user-interface-legacy';
import type { AnyGroup, GroupSelectionType, LayoutBoardGroupHeader } from '@core/views-types';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'rt-board-group-header',
  styleUrls: ['./board-group-header.component.less'],
  imports: [HeadingComponent, TruncateComponent, SymbolComponent, BadgeComponent],
  template: `
    @if (group().symbol; as symbol) {
      <rt-symbol [symbol]="symbol" margin-right-small-x />
    }
    <rt-heading variant="heading text-color">
      <rt-truncate>{{ group().label }}</rt-truncate>
    </rt-heading>
    @let countValue = count();
    @if (countValue !== null && countValue !== undefined) {
      <rt-badge color="counter-default" [text]="countValue" margin-left-small-x />
    }
  `,
})
export class BoardGroupHeaderComponent implements LayoutBoardGroupHeader {
  public group = input.required<AnyGroup>();
  public selectionInGroup = input.required<GroupSelectionType>();
  public count = input.required<number | null | undefined>();
  public select = output<AnyGroup>();
}
